export default __webpack_public_path__ + "static/media/oriental_v2.ab039df7.png";